module.exports = __webpack_public_path__ + "static/media/Icon3.405fad0b.svg";